const NextFeature = {
  Approvals: 'approvals',
  EntriesApprovals: 'entries-approvals',
  Leave: 'leave',
  Preferences: 'preferences',
  RateCards: 'rate-cards',
  Sources: 'sources',
  StaffTimeClocks: 'staff-time-clocks',
  StaffTimesheets: 'staff-timesheets',
  TimeClocks: 'time-clocks',
  Timesheets: 'timesheets',
} as const;

export interface ValidUrlDefinition {
  url: string;
  entity: string;
  queryParams: [string, string | number | boolean][];
}

export const buildUrlData = (
  target: string,
  path: string[],
  entity: string,
  queryParams: Record<string, string | number | boolean> = {},
): ValidUrlDefinition => ({
  url: `${target}/${path.join('/')}`,
  queryParams: Object.entries(queryParams),
  entity,
});

const buildTimesheetsUrlData = (
  target: string,
  path: string[],
  entityId: string,
  queryParams: Record<string, string | number | boolean> = {},
) => {
  const [isCreateAction, ...restPath] = path;
  if (path.length === 0) {
    return buildUrlData(target, path, entityId, queryParams);
  }
  if (isCreateAction === 'new') {
    return buildUrlData(target, restPath, entityId, {
      ...queryParams,
      create_new_timesheet: true,
    });
  }

  return buildUrlData('timesheet', path, entityId, queryParams);
};

const buildStaffTimesheetsUrlData = (
  target: string,
  path: string[],
  entityId: string,
  queryParams: Record<string, string | number | boolean> = {},
) => {
  if (path.length === 0) {
    return buildUrlData(target, path, entityId, queryParams);
  }

  const [isCreateAction, ...restPath] = path;

  if (isCreateAction === 'new') {
    return buildUrlData(target, restPath, entityId, {
      ...queryParams,
      create_new_timesheet: true,
    });
  }

  return buildUrlData('timesheet', path, entityId, {
    staff: true,
    ...queryParams,
  });
};

export const validateNextUrl = (originalUrl: string | null, entityId: string): ValidUrlDefinition | null => {
  const url = !originalUrl ? null : originalUrl;

  if (!url) {
    return null;
  }

  const [target, ...path] = url.split('/');

  switch (target) {
    case NextFeature.Sources:
      return buildUrlData('data-sources', path, entityId);
    case NextFeature.Preferences:
      return buildUrlData('time-preferences', path, entityId);
    case NextFeature.Timesheets:
      return buildTimesheetsUrlData(target, path, entityId);
    case NextFeature.StaffTimesheets:
      return buildStaffTimesheetsUrlData(target, path, entityId);
    // These cases have the same URL path as the key in the NEXT_FEATURE object
    case NextFeature.Approvals:
    case NextFeature.EntriesApprovals:
    case NextFeature.Leave:
    case NextFeature.RateCards:
    case NextFeature.StaffTimeClocks:
    case NextFeature.TimeClocks:
      return buildUrlData(target, path, entityId);
    default:
      return null;
  }
};
